"use client";

import { useMotionValueEvent, useScroll } from "motion/react";
import React, {
  useMemo,
  useRef,
  useState,
  useContext,
  createContext,
} from "react";

export const ModalScrollContext: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const value = useInitContext();
  return <Context value={value}>{children}</Context>;
};

export const useModalScrollContext = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error("ModalScrollContext not found");
  }

  return context;
};

const Context = createContext<ReturnType<typeof useInitContext> | undefined>(
  undefined
);

function useInitContext() {
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  const { isAtBottom } = useIsAtBottom(scrollAreaRef);

  return useMemo(
    () => ({
      isAtBottom,
      scrollAreaRef,
    }),
    [isAtBottom]
  );
}

const useIsAtBottom = (ref: React.RefObject<HTMLDivElement | null>) => {
  const [isAtBottom, setIsAtBottom] = useState(false);
  const { scrollYProgress } = useScroll({
    container: ref,
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    setIsAtBottom(latest >= 0.99);
  });

  return { isAtBottom };
};
